import React, { useEffect, useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import ProfileContextMenu from "./ProfileContextMenu";
import UnsavedChangesAlert from "../../ShareElements/UnsavedChangesAlert/UnsavedChangesAlert";
import NavBookmarksGuide from "../../UserGuide/Components/NavBookmarkGuide";
import { translateText } from "../../../../../Helper_functions";

const BookmarksBar = (props) => {
  const [BookmarkList, setBookmarksList] = useState([]);
  const [PrevNavItem, setPrevNavItem] = useState();
  const [HasUnsaveChanges, setUnsavedChanges] = useState(false);
  // FIX: store interval ID so we can clear it on unmount
  const intervalRef = useRef(null);

  useEffect(() => {
    checkRoles();
    if (window.innerWidth > 450) {
      // FIX: store interval ID in ref
      intervalRef.current = setInterval(() => {
        checkIndicatorVisibility();
      }, 100);
    }
    // FIX: clear interval when component unmounts to stop null classList errors
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);

  const checkRoles = () => {
    let RoleTypes = [];
    let IsESS = false;
    props.UserInfo.roles.map((Role) => {
      RoleTypes.push(Role.roleType);
    });
    if (RoleTypes.includes("EMPLOYEE_SELF_SERVICE") && RoleTypes.length === 1) {
      IsESS = true;
    } else {
      IsESS = false;
    }
    if (
      RoleTypes.includes("MANAGER_SELF_SERVICE") ||
      (RoleTypes.includes("HR_ADMIN") && RoleTypes.length > 1)
    ) {
      IsESS = false;
    }

    let Bookmarks = [...props.BookmarkList];
    let BookmarksLeft = [];
    let BookmarksRight = [];
    if (IsESS) {
      BookmarksLeft = [...props.BookmarkList].splice(0, 1);
      // this part is commented temporarily and must be reverted after all bookmark itmes are reverted
      // BookmarksRight = [...props.BookmarkList].splice(2, Bookmarks.length);
      BookmarksRight = [...props.BookmarkList].splice(1, Bookmarks.length);
      setBookmarksList(BookmarksLeft.concat(BookmarksRight));
    } else {
      setBookmarksList(Bookmarks);
    }
  };

  const setClassName = (ImageName) => {
    return ImageName + "-bookmark" + " bookmark-item";
  };

  const handleIndicatorPos = (ItemIndex, e, Id) => {
    setPrevNavItem(Id);
    let UnsavedChangesStatus = parseInt(
      window.localStorage.getItem("HasUnsaveChanges")
    ); //true: 1, false: 0
    if (UnsavedChangesStatus === 0) {
      document.getElementById(Id).click();
      // FIX: null guard on bookmark-indicator before setting style
      const indicator = document.getElementById("bookmark-indicator");
      if (!indicator) return;
      if (ItemIndex === 0) {
        indicator.style.transform = "none";
      }
      if (ItemIndex === 1) {
        indicator.style.transform = "translateY(65px)";
      }
      if (ItemIndex === 2) {
        indicator.style.transform = "translateY(127px)";
      }
      if (ItemIndex === 3) {
        indicator.style.transform = "translateY(191px)";
      }
      if (ItemIndex === 4) {
        indicator.style.transform = "translateY(253px)";
      }
      if (ItemIndex === 5) {
        indicator.style.transform = "translateY(320px)";
      }
      if (ItemIndex === 6) {
        indicator.style.transform = "translateY(385px)";
      }
    } else if (UnsavedChangesStatus === 1) {
      e.preventDefault();
      setUnsavedChanges(true);
    }
  };

  const discard = () => {
    window.localStorage.setItem("HasUnsaveChanges", 0);
    document.getElementById(PrevNavItem).click();
    setUnsavedChanges(false);
  };

  const saveAndLeave = () => {
    document.getElementById("save-btn").click();
    setTimeout(() => {
      let UnsavedChangesStatus = parseInt(
        window.localStorage.getItem("HasUnsaveChanges")
      ); //true: 1, false: 0
      if (UnsavedChangesStatus === 1) {
        setUnsavedChanges(false);
        return null;
      } else {
        document.getElementById(PrevNavItem).click();
        setUnsavedChanges(false);
      }
    }, 1500);
  };

  const translateTooltip = (Name) => {
    // Guard: LangData may not be loaded yet when component first renders
    if (!props.LangData || props.LangData.length === 0) return Name;
    if (Name === "Home") {
      return translateText("home", props.LangData);
    } else if (Name === "Dashboard") {
      return translateText("dashboard", props.LangData);
    } else if (Name === "Conversations") {
      return translateText("conversations", props.LangData);
    }
    return Name;
  };

  // This function is called in the useEffect hook inside an interval, and will check the window
  // pathname to make sure it is displayed in the correct paths only. The displaying
  // is handled through the classname given to the "bookmark-indicator" element
  const checkIndicatorVisibility = () => {
    let CurrentPathname = window.location.pathname;
    // FIX: null guard — element may not exist yet when interval first fires
    let IndicatorElement = document.getElementById("bookmark-indicator");
    if (!IndicatorElement) return;

    let Pathnames = [
      "/home",
      "/home/",
      "/home/communication",
      "/home/communication/",
      "/home/employeeDashboard",
      "/home/employeeDashboard/",
    ];

    if (Pathnames.includes(CurrentPathname)) {
      if (IndicatorElement.classList.contains("hidden")) {
        IndicatorElement.classList.remove("hidden");
      }
    } else {
      IndicatorElement.classList.add("hidden");
    }
  };

  const checkHRAdminAccess = (BookmarkItem, i) => {
    if (props.IsMobile) {
      if (BookmarkItem.Route === "/HRAdminDashboard") {
        if (
          props.UserInfo.roleTypes.includes("HR_ADMIN") ||
          props.UserInfo.superAdmin
        ) {
          return (
            <React.Fragment>
              {BookmarkItem.Image === "Logout" ? (
                <a
                  className="nav-bookmark logout-bookmark"
                  activeClassName={BookmarkItem.ActiveClassName}
                  onClick={() => props.setConfirmLogoutIsOpen(true)}
                >
                  <div className={setClassName(BookmarkItem.Image)}></div>
                </a>
              ) : (
                <NavLink
                  exact={BookmarkItem.IsExact}
                  className={
                    BookmarkItem.Image === "Logout"
                      ? "nav-bookmark logout-bookmark"
                      : BookmarkItem.ClassName
                  }
                  to={BookmarkItem.Route}
                  activeClassName={BookmarkItem.ActiveClassName}
                  onClick={() => props.hideNavMenu()}
                >
                  <div className={setClassName(BookmarkItem.Image)}></div>
                </NavLink>
              )}
            </React.Fragment>
          );
        } else {
          return null;
        }
      } else {
        return (
          <React.Fragment>
            {BookmarkItem.Image === "Logout" ? (
              <a
                className="nav-bookmark logout-bookmark"
                activeClassName={BookmarkItem.ActiveClassName}
                onClick={() => props.setConfirmLogoutIsOpen(true)}
              >
                <div className={setClassName(BookmarkItem.Image)}></div>
              </a>
            ) : (
              <NavLink
                exact={BookmarkItem.IsExact}
                className={
                  BookmarkItem.Image === "Logout"
                    ? "nav-bookmark logout-bookmark"
                    : BookmarkItem.ClassName
                }
                to={BookmarkItem.Route}
                activeClassName={BookmarkItem.ActiveClassName}
                onClick={() => props.hideNavMenu()}
              >
                <div className={setClassName(BookmarkItem.Image)}></div>
              </NavLink>
            )}
          </React.Fragment>
        );
      }
    } else {
      if (BookmarkItem.Route === "/HRAdminDashboard") {
        if (
          props.UserInfo.roleTypes.includes("HR_ADMIN") ||
          props.UserInfo.superAdmin
        ) {
          return (
            <NavLink
              exact={BookmarkItem.IsExact}
              className={BookmarkItem.ClassName}
              to={BookmarkItem.Route}
              activeClassName={BookmarkItem.ActiveClassName}
              onClick={(e) => handleIndicatorPos(i, e, BookmarkItem.id)}
            >
              <div
                className={setClassName(BookmarkItem.Image)}
                id={BookmarkItem.id}
              ></div>
            </NavLink>
          );
        } else {
          return null;
        }
      } else {
        return (
          <NavLink
            exact={BookmarkItem.IsExact}
            className={BookmarkItem.ClassName}
            to={props.NavBookmarksGuideIsOpen ? "/" : BookmarkItem.Route}
            activeClassName={
              props.NavBookmarksGuideIsOpen ? "" : BookmarkItem.ActiveClassName
            }
            onClick={(e) => handleIndicatorPos(i, e, BookmarkItem.id)}
          >
            <div
              className={setClassName(BookmarkItem.Image)}
              id={BookmarkItem.id}
            ></div>

            {BookmarkItem.TooltipText ? (
              <div className="tooltip">
                {translateTooltip(BookmarkItem.TooltipText)}
              </div>
            ) : null}
          </NavLink>
        );
      }
    }
  };

  const selectClassName = () => {
    if (
      props.UserInfo.roleTypes.includes("HR_ADMIN") ||
      props.UserInfo.superAdmin
    ) {
      return "bookmarks";
    } else {
      return "bookmarks ESS-bookmarks";
    }
  };

  return (
    <React.Fragment>
      {HasUnsaveChanges ? (
        <UnsavedChangesAlert
          close={() => setUnsavedChanges(false)}
          saveAndLeave={() => saveAndLeave()}
          discardAndLeave={() => discard()}
        />
      ) : null}
      <div className={selectClassName()}>
        <img src={props.Logo} alt="CX" className="x-small-logo" />
        {props.IsMobile ? (
          <section className="list">
            {props.BookmarkList.map((BookmarkItem, i) => (
              <>{checkHRAdminAccess(BookmarkItem, i)}</>
            ))}
          </section>
        ) : (
          <>
            {props.NavBookmarksGuideIsOpen ? (
              <div className="overlay"></div>
            ) : null}
            <section
              className={
                props.NavBookmarksGuideIsOpen
                  ? "list list-guide-is-open"
                  : "list"
              }
            >
              {props.NavBookmarksGuideIsOpen ? (
                <NavBookmarksGuide
                  LangData={props.LangData}
                  ToggleNextDialog={() => props.ToggleNextDialog()}
                  TogglePreviousDialog={() => props.TogglePreviousDialog()}
                  JumpToStep={(Step) => props.JumpToStep(Step)}
                  CloseGuide={() => props.CloseGuide()}
                  HasAdditionalStep={props.HasAdditionalStep}
                />
              ) : null}
              <span id="bookmark-indicator" className="fade-in-top"></span>
              {BookmarkList.map((BookmarkItem, i) => (
                <>{checkHRAdminAccess(BookmarkItem, i)}</>
              ))}
            </section>
          </>
        )}
        <section className="bookmarks-footer">
          {props.UserInfo === undefined ? null : (
            <ProfileContextMenu
              UserAvatar={props.UserAvatar}
              setConfirmLogoutIsOpen={(Bool) =>
                props.setConfirmLogoutIsOpen(Bool)
              }
              Name={props.UserInfo.firstName + " " + props.UserInfo.lastName}
              Role={
                props.UserInfo.roles.length === 0
                  ? null
                  : props.UserInfo.roles[0].name
              }
            />
          )}
        </section>
      </div>
    </React.Fragment>
  );
};

export default BookmarksBar;
